module.exports = __webpack_public_path__ + "img/quick_06.0c487e53.png";